<template>
  <q-select
    :value="value"
    :options="options"
    v-bind="$attrs"
    @input="(value) => $emit('input', value)"
  />
</template>

<script>
  import { ProjectsClient } from 'src/api/Projects'

  export default {
    data () {
      return {
        projects: []
      }
    },
    props: ['value'],
    computed: {
      options () {
        return this.projects.map((project) => ({
          label: project.name,
          value: project.id
        }))
      }
    },
    methods: {
      async fetchProjects () {
        let page = 1
        let totalPages = -Infinity

        do {
          await new ProjectsClient()
            .filter(['active', '=', 'true'])
            .limit(50)
            .page(page)
            .list()
            .then((response) => {
              const pagination = response.data.meta.pagination
              const projects = response.data.data

              this.projects = this.projects.concat(projects)
              page = page + 1
              totalPages = pagination.total_pages
            })
        } while (page < totalPages)
      }
    },
    created () {
      this.fetchProjects()
    }
  }
</script>
